import { defineComponent as A, openBlock as a, createElementBlock as l, mergeProps as Z, unref as o, renderSlot as d, createElementVNode as e, createCommentVNode as h } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, u = { key: 1 }, m = { key: 2 }, M = { key: 3 }, g = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconFileMinus"
}, _ = /* @__PURE__ */ A({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const s = V, { bind: r, weight: n } = i(s);
    return (H, t) => (a(), l("svg", Z({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(r)), [
      d(H.$slots, "default"),
      o(n) === "bold" ? (a(), l("g", p, t[0] || (t[0] = [
        e("path", { d: "M216.49,79.51l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.51ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Zm104-60a12,12,0,0,1-12,12H104a12,12,0,0,1,0-24h48A12,12,0,0,1,164,152Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (a(), l("g", u, t[1] || (t[1] = [
        e("path", {
          d: "M208,88H152V32Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,152Z" }, null, -1)
      ]))) : o(n) === "fill" ? (a(), l("g", m, t[2] || (t[2] = [
        e("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,160H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-72V43.31L196.69,88Z" }, null, -1)
      ]))) : o(n) === "light" ? (a(), l("g", M, t[3] || (t[3] = [
        e("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Zm-42-66a6,6,0,0,1-6,6H104a6,6,0,0,1,0-12h48A6,6,0,0,1,158,152Z" }, null, -1)
      ]))) : o(n) === "regular" ? (a(), l("g", g, t[4] || (t[4] = [
        e("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,152Z" }, null, -1)
      ]))) : o(n) === "thin" ? (a(), l("g", f, t[5] || (t[5] = [
        e("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Zm-44-68a4,4,0,0,1-4,4H104a4,4,0,0,1,0-8h48A4,4,0,0,1,156,152Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  _ as default
};
